export default __webpack_public_path__ + "static/media/Kshitish Kumar Mahapatra.1f67b95c.JPG";